export class ViewAdminDashboard {
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}

export class ViewAdminDashboardResponse {
    data_for: string;
    reason: string;
    reg_banks: number;
    reg_billers: number;
    reg_services: number;
    response: string;
    total_amount: number;
    total_txns: number;
}


export class ViewAdminTxnsDashboardGraphDataResponse {
    timeperiod: string[];
    txns: number[];
    amount: number[];
}

export class AdminPaymentKeyperFormanceIndicatorView {
    reason: string;
    response: string;
    total_amount: number;
    success_rate: number;
    txns_count: number;
}

export class AdminTxnsStaticsView {
    data_for: string;
    reason: string;
    response: string;
    bill_fetch: number;
    bill_paid: number;
    success_txns: number;
    total_visitors: number;
}

export class AdminTxnsRegBillerView {
    data_for: string;
    reason: string;
    response: string;
    registered_billers: RegisteredBiller[];
}
export class RegisteredBiller {
    biller_name: string;
    service_name: string;
    succ_txns: number;
    total_amt: number;
    total_txns: number;
}

export class BillerPerformance {
    blr_name: string[];
    no_of_txns: number[];
  total_amount: number[];
}

export class AssistedPerformance {
  payment_name: string[];
  total_amount: number[];
  no_of_txns: number[];
}

export class TopBiller {
    recordfor: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}

export class TopBillerResp {
    data_for: string;
    reason: string;
    record_for: string;
    response: string;
    top_records: string[];
}

export class AdminPaymentSuccessRateView {
    payment_name: string[];
    success: number[];
    fail: number[];
}

export class AdminPaymentTxnsAmountView {
    type: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}

export class AdminPaymentTxnsAmountViewResp {
    payment_name: string[];
    total_amount: number[];
}

export class InputOfVisitors {
    data_for: string;
    end_date: string;
    mode: string;
    start_date: string;
}

export class NumberOfVisitors {
    date_hour: string[];
    no_of_visitors: number[];
}



// WEBPACK FOOTER //
// ./src/app/dashboards/admin-dashboard/view-admin-dashboard.ts